'use strict';

exports.__esModule = true;
// This is an example of the actions for a component that the page will compose.
// It should export string constants for its action types (with a prefix e.g. SEARCH_BAR:GET_LOCATIONS)
// and use those in the action methods (e.g. getLocationAutocomplete).

// Things with API calls will use createAction as commented out below. See doctify/home-page.

var SET_ACTIVE_HEADER = exports.SET_ACTIVE_HEADER = 'PROFILE_RIGHT_SECTION_ACTIONS:SET_ACTIVE_HEADER';
var EXPAND_SECTION = exports.EXPAND_SECTION = 'PROFILE_RIGHT_SECTION_ACTIONS:EXPAND_SECTION';
var ENABLE_SCROLL = exports.ENABLE_SCROLL = 'PROFILE_RIGHT_SECTION_ACTIONS:ENABLE_SCROLL';
var DISABLE_SCROLL = exports.DISABLE_SCROLL = 'PROFILE_RIGHT_SECTION_ACTIONS:DISABLE_SCROLL';
var TOGGLE_EXPANDABLE_SECTION = exports.TOGGLE_EXPANDABLE_SECTION = 'PROFILE_RIGHT_SECTION_ACTIONS:TOGGLE_EXPANDABLE_SECTION';

var profileRightSectionActions = {
	setSectionActive: function setSectionActive(activeHeader) {
		return {
			type: SET_ACTIVE_HEADER,
			activeHeader: activeHeader
		};
	},
	expandableSectionClicked: function expandableSectionClicked(isExpanded, section) {
		return {
			type: TOGGLE_EXPANDABLE_SECTION,
			isExpanded: isExpanded,
			section: section
		};
	},
	enableScrollHighlight: function enableScrollHighlight() {
		return {
			type: ENABLE_SCROLL
		};
	},
	disableScrollHighlight: function disableScrollHighlight() {
		return {
			type: DISABLE_SCROLL
		};
	}
};

exports.default = profileRightSectionActions;


// WEBPACK FOOTER //
// ./components/specialist-page/lib/actions/profile-right-section.js